<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
const App = {
  name: 'app'
}
export default App
</script>

<style lang="stylus">
*{
  box-sizing: border-box;
}
html{
  font-size: 120px;
}
body{
  margin: 0;
  height: 100%;
  width: 100%;
}
#app {
  font-family: microsoft yahei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}
@font-face {
  font-family: 'iconfont';  /* project id 327073 */
  src: url('//at.alicdn.com/t/font_327073_0zqdoqgzttiysyvi.eot');
  src: url('//at.alicdn.com/t/font_327073_0zqdoqgzttiysyvi.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_327073_0zqdoqgzttiysyvi.woff') format('woff'),
  url('//at.alicdn.com/t/font_327073_0zqdoqgzttiysyvi.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_327073_0zqdoqgzttiysyvi.svg#iconfont') format('svg');
}
.iconfont{
  font-family: iconfont;
}
</style>



// WEBPACK FOOTER //
// App.vue?8fd5c9fc